import { useCallback } from 'react';

export type PermissionsType = {
  canRead: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canAudit: boolean;
  canDocument: boolean;
  isFullyAllowed?: boolean;
  isLoading?: boolean;
};
export const useGetPermissions = (abilities: string[]): PermissionsType => {
  const getPermissions = useCallback(() => {
    const possiblePermissions = {
      canRead: 'Read',
      canCreate: 'Create',
      canEdit: 'Edit',
      canAudit: 'Audit',
      canDocument: 'Document',
    };

    return Object.keys(possiblePermissions).reduce((acc, key) => {
      const permissionName =
        possiblePermissions[key as keyof typeof possiblePermissions];
      acc[key as keyof typeof acc] =
        abilities.includes(permissionName) ||
        (permissionName === 'Create' && abilities.includes('Edit'));
      return acc;
    }, {} as PermissionsType);
  }, [abilities]);

  return getPermissions();
};
